<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="PartModallLabel"
      >Scan Serial Code</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div class="d-flex w-100 justify-content-center align-items-center mb-2">
        <qrcode-stream
          :camera="camera"
          @decode="onDecode"
          @init="onInit"
          @locate="onLocate"
          :paused="paused"
          style="width: 100%; min-width: 300px; height: 50vh; background: #bfedff; overflow: hidden;"
          v-if="support == true"
          :torch="torchActive"
        >
          <div class="qrm_container">
            <div class="qrm_top_bottom" />
            <div class="qrm_middle">
              <div class="qrm_middle_l" />
              <div class="qrm_middle_m" />
              <div class="qrm_middle_r" />
            </div>
            <div class="qrm_top_bottom" />
          </div>
        </qrcode-stream>
        <div
          class="button-wrapper"
          v-if="support == false"
        >
          <span class="label">Press for Scan QR Code</span>
          <qrcode-capture
            @detect="onDetect"
            id="upload"
            class="upload-box"
          />
        </div>
      </div>
      <div class="row justify-content-center mt-2 mb-2">
        <div class="col-md-12 d-grid gap-2">
          <button
            @click="torchActive = !torchActive; playSuccess(); playFail();"
            v-if="!torchNotSupported"
            class="btn btn-rounded btn-outline-success btn-sm waves-effect waves-light btn-sm-fix"
          >
            <span v-if="!torchActive">
              <i class="ri-flashlight-line"></i> Open
            </span>
            <span v-if="torchActive">
              <i
                class="ri-flashlight-fill"
                v-if="torchActive"
              ></i> Close
            </span>

          </button>
          <div
            class="text-center w-100"
            v-if="torchNotSupported"
          >
            <small class="error">
              Flash not supported for active camera
            </small>
          </div>
        </div>
      </div>
      <div
        class="text-center"
        v-if="error != '' && error_show == true"
      >
        <span class="error">{{ error }}</span>
      </div>
      <table class="table mb-0 v-middle">
        <thead class="table-light">
          <tr>
            <th
              class="border-bottom border-top text-center"
              style="max-width: 10vw"
            >#</th>
            <th
              class="border-bottom border-top"
              style="max-width: 60vw"
            >Serial Code</th>
            <th
              class="border-bottom border-top text-center"
              style="max-width: 20vw"
            >Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(rs, i) in result_data"
            :key="'rs' + i"
          >
            <td
              class="text-center align-top"
              style="max-width: 10vw"
            >{{ i + 1 }}</td>
            <td
              class="align-top"
              style="max-width: 60vw"
            >{{ rs.serial_no }}</td>
            <td
              class="text-center align-top"
              style="max-width: 20vw"
            >
              <button
                class="btn btn-sm waves-effect waves-light btn-warning btn-sm-fix"
                @click="deleteSerialTemp(rs)"
              >Delete</button>
            </td>
          </tr>
          <tr v-if="result_data.length < 1">
            <td
              class="text-center"
              colspan="8"
            >No Data</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-fix"
        data-bs-dismiss="modal"
        id="supplierModalclose"
      >Close</button>
      <button
        v-if="result_data.length > 0"
        type="button"
        class="btn btn-danger btn-fix"
        @click="deleteSerialTempAll"
        id="submitbtn"
      >Delete All</button>
      <button
        v-if="result_data.length > 0"
        type="button"
        class="btn btn-info btn-fix"
        @click="addSerial"
        id="submitbtn"
      >Import Serial</button>
    </div>
    <audio
      id="myAudio"
      style="width: 0px; height: 0px;"
    >
      <source
        id="audioSource"
        type="audio/mpeg"
      />
    </audio>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
import swal from 'sweetalert2'
import api from '../../models/imports'

export default {
  props: ['modalScanData', 'search', 'editRefash'],
  data () {
    return {
      result_data: [],
      result: '',
      error: '',
      paused: false,
      support: true,
      error_show: false,
      camera: 'off',
      torchActive: false,
      torchNotSupported: false
    }
  },
  components: { QrcodeStream, QrcodeCapture },
  methods: {
    playSuccess () {
      const x = document.getElementById('myAudio')
      var source = document.getElementById('audioSource')
      source.src = require('../../assets/success.mp3')
      x.load()
      x.play()
    },
    playFail () {
      const x = document.getElementById('myAudio')
      var source = document.getElementById('audioSource')
      source.src = require('../../assets/fail.mp3')
      x.load()
      x.play()
      setTimeout(() => {
        x.pause()
        x.currentTime = 0
      }, 500)
    },
    onDecode (result) {
      this.result = result
      this.paused = true
      // $('.preloader').fadeIn()
      this.scanSerial(result)
    },
    async onDetect (promise) {
      try {
        const { content } = await promise

        if (content === null) {
          Swal.fire({
            title: '<strong style="font-family: \'Mitr\', sans-serif">Machine</strong>',
            type: 'warning',
            html: '<span style="font-family: \'Mitr\', sans-serif; color: red;">No Machine</span>'
          })
        } else {
          this.scanSerial(content)
          this.paused = true
        }
      } catch (error) {
        Swal.fire({
          title: '<strong style="font-family: \'Mitr\', sans-serif">Machine</strong>',
          type: 'warning',
          html: '<span style="font-family: \'Mitr\', sans-serif; color: red;">No Machine</span>'
        })
      }
    },
    async onInit (promise) {
      try {
        const { capabilities } = await promise
        this.support = true
        this.torchNotSupported = !capabilities.torch
      } catch (error) {
        this.support = true
        if (error.name === 'NotAllowedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: Stream API is not supported in this browser'
        }
      }
    },
    onLocate (points) {
      console.log(points)
    },
    scanSerial (code) {
      var obj = {
        recd_id: this.modalScanData.recd_id,
        ps_id: this.modalScanData.ps_id,
        serial_no: code
      }
      this.header.params = {}
      api.addSerialTemp(
        this.$store.state.URLHost,
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.playSuccess()
            this.listSerialTemp()
            this.alert_msg('success', 'Scan QR serial', result.message)
          } else {
            this.playFail()
            this.alert_msg('warning', 'Scan QR serial', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'Scan QR serial', error.message)
          $('#ScanModal').modal('hide')
        }
      )
    },
    addSerial () {
      var obj = {
        recd_id: this.modalScanData.recd_id,
        ps_id: this.modalScanData.ps_id
      }
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm Impost serial code all.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0acc95',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Impost serial code all!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            api.addSerial(
              this.$store.state.URLHost,
              obj,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.listSerialTemp()
                this.search()
                this.editRefash()
                $('#ScanModal').modal('hide')
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.listSerialTemp()
                $('#ScanModal').modal('hide')
              }
            )
          }
        })
    },
    listSerialTemp () {
      $('.preloader').fadeIn()
      var obj = {
        recd_id: this.modalScanData.recd_id
      }
      this.header.params = obj
      api.listSerialTemp(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'List serial code', result.message)
          }
          $('.preloader').fadeOut()
        },
        error => {
          this.alert_msg('error', 'An error occurred', error.message)
          $('.preloader').fadeOut()
        }
      )
    },
    deleteSerialTemp (obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete serial code : ' + obj.serial_no,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            api.deleteSerialTemp(
              this.$store.state.URLHost,
              obj.id,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.listSerialTemp()
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.listSerialTemp()
              }
            )
          }
        })
    },
    deleteSerialTempAll () {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete serial code all.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            api.deleteSerialTempAll(
              this.$store.state.URLHost,
              this.modalScanData.recd_id,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.listSerialTemp()
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.listSerialTemp()
              }
            )
          }
        })
    }
  },
  mounted () {
    var myModal = document.getElementById('ScanModal')
    myModal.addEventListener('hide.bs.modal', event => {
      if (event.target.id === 'ScanModal') {
        this.camera = 'off'
        this.result_data = []
        this.support = false
        this.paused = true
        this.torchActive = false
      }
    })
    myModal.addEventListener('show.bs.modal', event => {
      if (event.target.id === 'ScanModal') {
        this.camera = 'auto'
        this.support = true
        this.paused = false
        this.listSerialTemp()
      }
    })
  }
}
</script>

<style lang="css" scoped>
.button-wrapper {
  position: relative;
  width: 300px;
  text-align: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  height: 280px;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding-top: 43%;
  text-transform: uppercase;
  font-size: 18px;
}

#upload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 280px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.qrm_container {
  display: flex;
  flex-direction: column;
  height: 50vh;
}
.qrm_top_bottom {
  width: 100%;
  flex: 1;
  background-color: rgba(1, 1, 1, 0.5);
}
.qrm_middle {
  display: flex;
  flex-direction: row;
  height: 300px;
}
.qrm_middle_l {
  flex: 1;
  background-color: rgba(1, 1, 1, 0.5);
}
.qrm_middle_m {
  width: 300px;
  background-color: transparent;
  background: linear-gradient(to right, #00ff00 2px, transparent 2px) 0 0, linear-gradient(to right, #00ff00 2px, transparent 2px) 0 100%,
    linear-gradient(to left, #00ff00 2px, transparent 2px) 100% 0, linear-gradient(to left, #00ff00 2px, transparent 2px) 100% 100%,
    linear-gradient(to bottom, #00ff00 2px, transparent 2px) 0 0, linear-gradient(to bottom, #00ff00 2px, transparent 2px) 100% 0,
    linear-gradient(to top, #00ff00 2px, transparent 2px) 0 100%, linear-gradient(to top, #00ff00 2px, transparent 2px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 20px 20px;
}
.qrm_middle_r {
  flex: 1;
  background-color: rgba(1, 1, 1, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/modal/receive_imports_modal.vue